export function appProtocolDisplayName(app) {
    if (app.slug == 'enterprise-password-manager') {
        return 'Enterprise Password Manager';
    } else if (app.slug == 'generic-oauth2') {
        return 'OAUTH2';
    } else if (app.slug.endsWith('proxy-sso')) {
        return 'PROXY SSO';
    } else if (app.slug == 'custom') {
    	return 'SAASPASS REST API'
    } else if (app.slug == 'computer-login' || app.slug == 'computer-protection-without-ad') {
    	return 'COMPUTER LOGIN'
    } else if (app.slug == 'ad-password-manager') {
    	return 'AD Password Manager'
    } else if (app.oidc) {
        return 'OIDC';
    } else if (app.vpnRdp) {
        return 'VPN/RDP';
    } else if (app.saml) {
        return 'SAML';
    } else if (app.radius) {
        return 'Radius';
    } else if (app.mfaAdapter) {
        return 'MFA Adapter';
    }
}

export function generatePassword(length)
{
  let pool = "";
  let lower, upper, numbers;
  lower = upper = numbers = true;
  let symbols = false;
  if (lower) pool += "abcdefghijklmnopqrstuvwxyz";
  if (upper) pool += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  if (numbers) pool += "1234567890";
  if (symbols) pool += "`~!@#$%^&*()_-+={}[]\\|:;\"'<>,.?/";

  return Array.from({ length })
    .map(() => pool[Math.floor(Math.random() * pool.length)])
    .join("");
};


// WEBPACK FOOTER //
// ./src/util/sp-util.js